<template>
  <div class="flex flex-col justify-between mx-auto app-shell bg-blue">
    <router-view />
  </div>
</template>

<style lang="postcss">
@reference "./assets/css/tailwind.css";

body {
  @apply bg-blue;
}
.app-shell {
  width: 100%;
  min-height: 100vh;
}
@media (min-width: 640px) {
  .app-shell {
    max-width: 480px;
  }
}
@media (min-width: 768px) {
  .app-shell {
    max-width: 540px;
  }
}
.transit {
  transition: all 0.3s ease-in-out 0s;
}
</style>
